var script_loaded = false;
function loadJSscripts() {
  if (!script_loaded) {
    // Stop observing DOM changes
    if (typeof observer != "undefined") {
      observer.disconnect();
    }
    script_loaded = true;
    // Load lazy iframes
    document.querySelectorAll("iframe.lazy").forEach((iframe) => {
      let datasrc = iframe.dataset.src;
      if (datasrc != null) {
        iframe.src = datasrc;
      }
    });
    // Load lazy scripts
    var scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute("data-src") !== null) {
        scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
        delete scripts[i].dataset.src;
      }
      // Handle scripts with type 'text/lazyload'
      if (scripts[i].getAttribute("type") === "text/lazyload") {
        let newScript = document.createElement("script");
        for (let a = 0; a < scripts[i].attributes.length; a++) {
          let attr = scripts[i].attributes[a];
          newScript.setAttribute(attr.name, attr.value);
        }
        newScript.type = "text/javascript";
        newScript.innerHTML = scripts[i].innerHTML;
        scripts[i].parentNode.removeChild(scripts[i]);
        scripts[i].parentNode.insertBefore(newScript, scripts[i]);
      }
    }
    // Load lazy links
    var links = document.getElementsByTagName("link");
    for (let i = 0; i < links.length; i++) {
      if (links[i].getAttribute("data-href") !== null) {
        links[i].setAttribute("href", links[i].getAttribute("data-href"));
        delete links[i].dataset.href;
      }
    }
    // Dispatch custom event after lazy load
    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
    window.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  }
}
// List of events to trigger lazy loading
var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];
// Add event listeners for lazy loading
activityEvents.forEach(function (event) {
  window.addEventListener(event, loadJSscripts, false);
});
// Ensure load event listeners are attached
if (window.addEventListener) {
  window.addEventListener("load", function () {}, false);
} else if (window.attachEvent) {
  window.attachEvent("onload", function () {});
} else {
  window.onload = (event) => {};
}
